// Copyright (c) 2020 Deere & Company

import RgaSearchResult from '../../rga/rga-search-results/state-connector';

export default {
    component: RgaSearchResult,
    name: 'Part Request Results',
    path: '/rga/results'
};




// WEBPACK FOOTER //
// ./src/routes/rga/rga-results.js